import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate, Outlet, useParams, useLocation } from "react-router";
import api from "utils/axiosInstance";
import { UserContext } from "context/User/UserContext";
import ErrorComponent from "components/Error";

const AllModules = ({ modules }) => {
  const navigate = useNavigate();

  const openModule = (moduleData) => {
    navigate(`${moduleData.id}/learning`);
  };

  // const OpenTask = (taskName) => {
  //   navigate(`/dashboard/subject/tasks/${taskName}`);
  // };

  return (
    <Container>
      <Row>
        <h1 className="my-4">PsychoEducation Training</h1>
        {/* <div>
          {" "}
          <span onClick={() => OpenTask("arithmetic")}>
            Arithmetic Task
          </span> | <span onClick={() => OpenTask("stroop")}>Stroop Task</span>
        </div> */}
      </Row>

      <Row>
        {modules.map((slide) => (
          <Col md={4} key={slide.id} className="mb-4">
            <Card>
              <Card.Body>
                <Card.Img
                  variant="top"
                  src={process.env.PUBLIC_URL + slide.thumbnailImg}
                  alt={slide.title}
                />
                <Card.Title>{slide.title}</Card.Title>
                {slide.isLocked ? (
                  <Button variant="secondary" disabled>
                    Locked
                  </Button>
                ) : (
                  <Button variant="primary" onClick={() => openModule(slide)}>
                    View Module
                  </Button>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Modules = () => {
  const [modules, setModules] = useState([]);
  const [error, setError] = useState({ state: false, message: "" });

  const { user } = useContext(UserContext);

  const location = useLocation();
  const params = useParams();

  const { moduleNumber } = params;
  const weekNumberInt = parseInt(moduleNumber);

  useEffect(() => {
    (async function () {
      var moduleInfo;
      if (user) {
        moduleInfo = await getModuleInformation(user.username);
        setModules(moduleInfo);
      }
    })();
  }, []);

  const isModulePage =
    location.pathname.startsWith("/dashboard/subject/edu/modules") &&
    !moduleNumber;

  //TODO: Is this needed? This logic makes no sense
  const isArithmeticTaskPage =
    location.pathname.startsWith("/dashboard/subject/tasks/arithmetic") &&
    !moduleNumber;

  const isStroopTaskPage =
    location.pathname.startsWith("/dashboard/subject/tasks/stroop") &&
    !moduleNumber;

  const isPresentationPage =
    location.pathname.startsWith("/dashboard/subject/edu/modules/") &&
    weekNumberInt &&
    location.pathname.includes("learning");

  const isQuizPage =
    location.pathname.startsWith("/dashboard/subject/edu/modules/") &&
    weekNumberInt &&
    location.pathname.includes("quiz");

  async function getModuleInformation(subjectId) {
    try {
      const moduleInfo = await api({
        method: "get",
        url: `/edu/module/${subjectId}/data`,
      });
      return moduleInfo.data;
    } catch (err) {
      if (err.response && err.response.data)
        setError({
          state: true,
          message:
            (err.response && err.response.data.message) ||
            "An Unknown error occured",
        });
    }
  }

  if (error.state) return <ErrorComponent message={`${error.message}`} />;

  if (isArithmeticTaskPage) return <AllModules modules={modules} />;

  if (isStroopTaskPage) return <AllModules modules={modules} />;

  if (isModulePage) return <AllModules modules={modules} />;

  if (isPresentationPage)
    return (
      <Outlet
        context={{
          weekNumber: weekNumberInt,
          moduleData: modules.filter((m) => m.id === weekNumberInt)[0],
        }}
      />
    );

  if (isQuizPage)
    return (
      <Outlet
        context={{
          prevWeek: weekNumberInt,
        }}
      />
    );
};

export default Modules;
